export default __webpack_public_path__ + "static/media/furaha.ca280b9f.png";